import ActiveLinesAndAgents from "../../../components/dashboards/ActiveLinesAndAgents";
import FilteredAnalytics from "../../../components/dashboards/FilteredAnalytics";
import SelectLineAndDate from "../../../components/dashboards/SelectLineAndDate";
import TripsSalesAnalytics from "../../../components/dashboards/TripsSalesAnalytics";

const OperatorsDashboard = () => {
  return (
    <div className="flex flex-col-reverse md:flex-col gap-6">
      <ActiveLinesAndAgents />
      {/* <LineSalesAnalytics /> */}
      <div>
      <SelectLineAndDate />
      <div className="flex flex-col md:flex-row justify-between gap-5">
        <TripsSalesAnalytics />
        <FilteredAnalytics />
      </div>
      </div>
      {/* <div className=" flex flex-col md:flex-row gap-5">
            <TicketsToBePaidOnBusAnalytics />
            <AgentSalesAnalytics />
            <OfficeAndOnlineSalesAnalytics />
          </div>
      <BundleAnalytics /> */}
    </div>
  );
};

export default OperatorsDashboard;
